<template>
  <a-drawer width="42%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="areaId">
        <span slot="label"><a-tooltip>{{ $t('省份') }}<template slot="title">{{ $t('省份') }}</template></a-tooltip></span>
        <a-select :placeholder="$t('请选择') + $t('省份')" style="width: 100%" v-model="form.areaId" allowClear :disabled="formType === 2" @change="onProvinceChange">
          <a-select-option v-for="(item, index) in provinceList" :value="item.areaId" :key="'p-' + index">
            {{ item.areaName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="areaName">
        <span slot="label"><a-tooltip>{{ $t('专区名称') }}<template slot="title">{{ $t('专区名称') }}</template></a-tooltip></span>
        <a-input v-model="form.areaName" :maxLength="255" :placeholder="$t('请输入') + $t('专区名称')" />
      </a-form-model-item>
      <!-- 修改：单城市（只读展示） -->
      <a-form-model-item prop="cityIdList">
        <span slot="label"><a-tooltip>{{ $t('城市') }}<template slot="title">{{ $t('城市') }}</template></a-tooltip></span>
        <a-select mode="multiple" placeholder="请选择城市" style="width: 100%" v-model="form.cityIdList" allowClear
          @change="onCityIdListChange">
          <a-select-option v-for="(item, index) in this.cityList" :value="item.areaId" :key="index">
            {{ item.areaName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if=" form.cityIdList && form.cityIdList.length > 0" prop="childrenList">
        <span slot="label"><a-tooltip>{{ $t('地区') }}<template slot="title">{{ $t('地区') }}</template></a-tooltip></span>
        <a-table rowKey="areaId" :data-source="form.childrenList" :columns="cityColumns" :pagination="false" bordered>
          <div slot="areaName" slot-scope="text, record" >
            <a-input v-model="record.areaName" :maxLength="20" :placeholder="$t('请输入')+$t('地区名称')"/>
          </div>
          <div slot="cityName" slot-scope="text, record" >
            <span>{{getCityName(record)}}</span>
          </div>
        </a-table>
      </a-form-model-item>


      <a-form-model-item prop="coverImg">
        <span slot="label"><a-tooltip>{{ $t('封面图') }}<template slot="title">{{ $t('封面图') }}</template></a-tooltip></span>
        <oss-upload-single :height="100" :width="100" v-model="form.coverImg" prefix="activity" type="img" />
      </a-form-model-item>
<!--      <a-form-model-item prop="detailImg">
        <span slot="label"><a-tooltip>{{ $t('详情图') }}<template slot="title">{{ $t('详情图') }}</template></a-tooltip></span>
        <oss-upload-single :height="100" :width="100" v-model="form.detailImg" prefix="activity" type="img" />
      </a-form-model-item>-->

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSchoolArea, addSchoolArea, updateSchoolArea } from '@/api/school/schoolArea'
import OssUploadSingle from '@/components/OssUploadSingle/index.vue'
import {mapGetters} from 'vuex'
import moment from 'moment'
import {cityListTree} from "@/api/logistics";
import Editor from "@/components/Editor";
import CustomDictTag from "@/components/DictCustomTag/index.vue";
export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag, Editor,
    OssUploadSingle
  },
  data () {
    return {
      provinceList: [],
      cityList: [],

      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      cityColumns: [
        {
          title: this.$t('城市编号'),
          dataIndex: 'areaId',
          key: 'areaId',
        }, {
          title: this.$t('城市名称'),
          dataIndex: 'cityName',
          scopedSlots: { customRender: 'cityName' },
          key: 'cityName'
        }, {
          title: this.$t('地区名称'),
          dataIndex: 'areaName',
          key: 'areaName',
          scopedSlots: { customRender: 'areaName' }
        }
      ],
      // 表单参数
      form: {
        id: null,
        areaId: null,
        areaName: null,
        coverImg: null,
        detailImg: null,
        remark: null,
        cityIdList: [],
        childrenList: [],
        localeFieldMap:{},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        areaId: [{required: true, message: this.$t('省份') + this.$t('不能为空'), trigger: 'change'}],
        areaName: [{required: true, message: this.$t('专区名称') + this.$t('不能为空'), trigger: 'blur'}],
        cityIdList: [{required: true, message: this.$t('城市') + this.$t('不能为空'), trigger: 'blur'}],

      }
    }
  },
  filters: {
  },
  created () {
    this.getCityTree()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    moment,
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.cityList = []
      this.form = {
        id: null,
        areaId: null,
        areaName: null,
        coverImg: null,
        detailImg: null,
        remark: null,
        cityIdList: [],
        childrenList: [],
        localeFieldMap:{},
      }

    },

    getCityTree() {
      cityListTree().then(response => {
        this.provinceList = response.data
      })
    },
    onProvinceChange (value) {
      this.form.cityIdList = []
      this.form.childrenList = []
      if (value === undefined || value === null || value === '') {
        this.cityList = []
        return
      }
      const prov = this.provinceList.find(
        (p) => p.areaId === value || String(p.areaId) === String(value)
      )
      this.cityList = prov && prov.children ? prov.children : []
    },
    /**
     * 城市多选变化：与 form.childrenList 同步（选中追加、取消移除，已填地区名称尽量保留）
     */
    onCityIdListChange (selectedIds) {
      const ids = selectedIds || []
      const prev = this.form.childrenList || []
      const next = []
      ids.forEach((id) => {
        const existing = prev.find((r) => String(r.areaId) === String(id))
        const city = this.cityList.find((c) => String(c.areaId) === String(id))
        if (existing) {
          next.push(existing)
        } else {
          next.push({
            areaId: id,
            cityName: city ? city.areaName : '',
            areaName: ''
          })
        }
      })
      this.form.childrenList = next
    },
    getCityName(record) {
      if (record.cityName) {
        return record.cityName
      } else {
        //从cityList中拿
        const city = this.cityList.find((c) => String(c.areaId) === String(record.areaId))
        return city ? city.areaName : ''
      }
    },

    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSchoolArea({"id":id}).then(response => {
        this.form = response.data
        const prov = this.provinceList.find((p) => p.areaId === response.data.areaId || String(p.areaId) === String(response.data.areaId))
        this.cityList = prov && prov.children ? prov.children : []
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateSchoolArea(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addSchoolArea(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>